import { createSelector } from 'reselect'

import { isPublisherSelector } from 'selectors'
import { isReschedulingSelector } from 'selectors/current_invitee'

export const isPublisherAndReschedulingSelector = createSelector(
  isPublisherSelector,
  isReschedulingSelector,
  (isPublisher, isRescheduling) => (isPublisher && isRescheduling)
)
